var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292",
    transform: "translate(-30 -190)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(30 190)",
    fill: "#FCE3E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291",
    transform: "translate(10160 -8356.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290",
    transform: "translate(-10126 8554.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3569",
    "data-name": "Path 3569",
    d: "M856.693,556.717a3.826,3.826,0,0,0-7.648,0Z",
    transform: "translate(-844.454 -547.79)",
    fill: "none",
    stroke: "#FC0057",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 2.04,
    cy: 2.04,
    r: 2.04,
    transform: "translate(6.393)",
    fill: "none",
    stroke: "#FC0057",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288",
    transform: "translate(0 2.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3570",
    "data-name": "Path 3570",
    d: "M727.4,576.245a2.968,2.968,0,0,0-4.36,2.535h3.46",
    transform: "translate(-723.045 -571.857)",
    fill: "none",
    stroke: "#FC0057",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 1.582,
    cy: 1.582,
    r: 1.582,
    transform: "translate(1.397)",
    fill: "none",
    stroke: "#FC0057",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289",
    transform: "translate(12.316 2.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3571",
    "data-name": "Path 3571",
    d: "M1066.6,576.245a2.968,2.968,0,0,1,4.36,2.535h-3.46",
    transform: "translate(-1066.395 -571.857)",
    fill: "none",
    stroke: "#FC0057",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 1.582,
    cy: 1.582,
    r: 1.582,
    transform: "translate(0)",
    fill: "none",
    stroke: "#FC0057",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkActive);
export default __webpack_public_path__ + "static/media/network-active.a3e6173186035a4f9215641efd921f95.svg";
export { ForwardRef as ReactComponent };